/* @flow */

import moment from 'moment';

const dataBrasileiraParaAmericana = (dataBrasileira: string) => (
    moment(dataBrasileira, 'DD/MM/YYYY').format('YYYY-MM-DD')
);

export default dataBrasileiraParaAmericana;
